import type { ComponentSchema } from "../../../../../schema-types";
import { SUPPORTED_PAGES, SECTION_STYLE_FIELDS } from "../../_builder-constants";

const INSTAGRAM_ITEM_SCHEMA = [
  { key: "image", label: "Image", type: "image" as const },
  { key: "link", label: "Link URL", type: "string" as const },
];

const POSTER_ITEM_SCHEMA = [
  { key: "image", label: "Poster", type: "image" as const, help: "Tall, about 800 × 1000 px (4:5)." },
  { key: "caption", label: "Caption (optional)", type: "string" as const, help: "Shown under the poster; also describes it for screen readers." },
  { key: "link", label: "Link", type: "string" as const, placeholder: "/shop" },
];

export const schema: ComponentSchema = {
  type: "instagram-feed",
  label: "Instagram Feed",
  description: "Display a grid of Instagram photos with hover effects, or a carousel of portrait posters.",
  supportedPages: [...SUPPORTED_PAGES],
  variants: [
    {
      id: "v1",
      label: "Photo strip",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle (e.g. @yourstore)", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: INSTAGRAM_ITEM_SCHEMA },
      ],
    },
    {
      id: "v2",
      label: "Photo strip, handle on hover",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: INSTAGRAM_ITEM_SCHEMA },
      ],
    },
    {
      id: "v3",
      label: "Four large tiles",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: INSTAGRAM_ITEM_SCHEMA },
      ],
    },
    {
      id: "v4",
      label: "Mosaic",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: INSTAGRAM_ITEM_SCHEMA },
      ],
    },
    {
      id: "v5",
      label: "Poster carousel",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "Highlights" },
        { key: "handle", label: "Small line above the title (optional)", type: "string" },
        { key: "items", label: "Posters", type: "array", itemSchema: POSTER_ITEM_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
